import React from 'react';
import PropTypes from 'prop-types';
import {Route, Switch} from 'react-router-dom';
import ProductDetails from './ProductDetails';

const ProductDetailsWrapper = props => (
    <Switch>
        <Route exact path="/" render={() => <ProductDetails {...props} />}/>
    </Switch>
);

ProductDetailsWrapper.propTypes = {
    idpUrl: PropTypes.string,
    assets: PropTypes.shape({
        defaultOrganisationNonEditableLogoUrl: PropTypes.string.isRequired,
        defaultOrganisationNonEditableLogoMobileUrl: PropTypes.string.isRequired,
        defaultParticipantPhotoUrl: PropTypes.string,
        defaultParticipantPhotoMobileUrl: PropTypes.string
    }).isRequired,
    context: PropTypes.shape({
        interfaceLocale: PropTypes.string.isRequired,
        primaryLocale: PropTypes.string.isRequired,
        exhibitingOrganisationId: PropTypes.string.isRequired,
        eventEditionId: PropTypes.string.isRequired,
        showPlanningEnabled: PropTypes.bool
    }).isRequired,
    baseApiUrl: PropTypes.string.isRequired,
    navigation: PropTypes.shape({
        participantProtectedDirectory: PropTypes.string,
        participantProtectedDetails: PropTypes.string,
        exhibitorPublicDetailsUrlFormat: PropTypes.string
    }),
    algoliaConfig: PropTypes.shape({
        appId: PropTypes.string.isRequired,
        apiKey: PropTypes.string.isRequired
    })
}

export default ProductDetailsWrapper;
